export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: 'b0373864-6a64-4be6-8eba-1cd76e45d5a3',
      authority: 'https://ProteorCoreNpdFR.b2clogin.com/ProteorCoreNpdFR.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      knownAuthorities: ['proteorcorenpdfr.b2clogin.com'],
    },
  },
  apiConfig: {
    profile: {
      scopes: [
        'https://ProteorCoreNpdFR.onmicrosoft.com/a0ceae77-6a08-4261-bc9b-99a22e9d55b2/profile.user_impersonation',
      ],
      uri: 'https://api.profile.proteor.dev',
    },
    // ProID : même app B2C que ProFile mais SCOPE dédié (proid.user_impersonation) — token distinct.
    proid: {
      scopes: [
        'https://ProteorCoreNpdFR.onmicrosoft.com/a0ceae77-6a08-4261-bc9b-99a22e9d55b2/proid.user_impersonation',
      ],
      uri: 'https://api.proid.proteor.dev',
    },
    // ProSync partage l'app/scope B2C de ProFile : on réutilise profile.scopes pour le token.
    sync: {
      uri: 'https://func.prosync.proteor.dev',
    },
  },
}

